module.exports = __webpack_public_path__ + "img/strategic-3.7e8211d0.png";